import { isMatch } from "@/utils/utils";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Cart Item Interface
export interface VivaCartItem {
  id: number;
  group_name: string;
  "Sub Type"?: string;
  sub_type?: string;
  fc_fees_type_id?: number;
  Category?: string;
  school_id?: string;
  event_fee?: number;
  price?: number;
  inCart: number;
  maximum_entry?: number;
  SelectedEvent?: { [key: string]: any };
  image_link?: string | string[];
  venue_name?: string;
  host_school_name?: string;
  gender?: string;
  age?: any;
  key?: any;
  // isPrivate?: boolean;
  participation_type?: string;
  // is_private?: false;
}

// State Interface
interface CartState {
  items: VivaCartItem[];
}

// Initial State
const initialState: CartState = {
  items: [],
};

// Create Slice
const vivaCartSlice = createSlice({
  name: "vivaCart",
  initialState,
  reducers: {
    addVivaItem: (
      state,
      action: PayloadAction<{ data: VivaCartItem; persist: boolean }>,
    ) => {
      const { data: payload, persist } = action.payload;
      // if there is no key in the payload that mean its a newly added event
      // if there is key in payload check for existing event and update the incart
      const existingItem = state.items.find((item) => {
        return (
          item.group_name === action.payload.data.group_name &&
          item.key === action.payload.data.key &&
          item.Category === action.payload.data.Category &&
          item.sub_type === action.payload.data.sub_type &&
          item.participation_type === action.payload.data.participation_type
          // item.participation_type === action.payload.data.participation_type &&
          // item.isPrivate === action.payload.data.isPrivate
        );
      });
      if (!persist) {
        localStorage.removeItem("promoCodeData");
        localStorage.removeItem("formData");
      }
      const key = `${payload.group_name}-${payload.sub_type}-${payload.Category}-${Date.now()}-${Math.random()
        .toString(36)
        .substring(2, 8)}`;
      const finalKey = existingItem ? existingItem.key : key;

      if (existingItem) {
        existingItem.inCart += 1;
      } else {
        state.items.unshift({ ...payload, key: finalKey, inCart: 1 });
      }
      try {
        const raw = localStorage.getItem("formData");
        let formDataArray: any[] = [];

        if (raw) {
          if (raw.trim().startsWith("{")) {
            const parsed = JSON.parse(raw);
            formDataArray = parsed.formData || [];
          } else {
            formDataArray = JSON.parse(raw);
          }
        }
        const newFormData = {
          key: finalKey,
          subType: payload.sub_type,
          category: payload.Category,
          group_name: payload.group_name,
          // isPrivate: payload.isPrivate,
        };

        formDataArray.push(newFormData);

        const finalData =
          raw && raw.trim().startsWith("{")
            ? { formData: formDataArray }
            : formDataArray;

        localStorage.setItem("formData", JSON.stringify(finalData));
        console.log("updated formdata", finalData);
      } catch (err) {
        console.error("Error updating localStorage.formData:", err);
      }
    },
    addVivaSameItem: (
      state,
      action: PayloadAction<{ data: VivaCartItem; persist: boolean }>,
    ) => {
      const { data: payload, persist } = action.payload;

      if (!persist) {
        localStorage.removeItem("promoCodeData");
        localStorage.removeItem("formData");
      }

      const key = `${payload.group_name}-${payload.sub_type}-${payload.Category}-${Date.now()}-${Math.random()
        .toString(36)
        .substring(2, 8)}`;

      state.items.unshift({
        group_name: payload.group_name,
        sub_type: payload.sub_type,
        Category: payload.Category,
        image_link: payload.image_link,
        // venue_name: payload.venue_name, // removed because it will auto set and apply filters after adding to cart
        host_school_name: payload.host_school_name,
        key,
        participation_type: payload.participation_type,
        // isPrivate: payload.isPrivate,
        inCart: 1,
      } as VivaCartItem);

      try {
        const raw = localStorage.getItem("formData");
        let formDataArray: any[] = [];

        if (raw) {
          if (raw.trim().startsWith("{")) {
            const parsed = JSON.parse(raw);
            formDataArray = parsed.formData || [];
          } else {
            formDataArray = JSON.parse(raw);
          }
        }

        const newFormData = {
          key,
          subType: payload.sub_type,
          category: payload.Category,
          group_name: payload.group_name,
          // isPrivate: payload.isPrivate,
        };

        formDataArray.push(newFormData);

        const finalData =
          raw && raw.trim().startsWith("{")
            ? { formData: formDataArray }
            : formDataArray;

        localStorage.setItem("formData", JSON.stringify(finalData));
        console.log("updated formdata", finalData);
      } catch (err) {
        console.error("Error updating localStorage.formData:", err);
      }
    },

    updateVivaItemAttributes: (
      state,
      action: PayloadAction<{
        key: string | number;
        updates?: Partial<{
          venue_name: string;
          host_school_name: string;
          age: string;
          gender: string;
          sub_type: string;
          group_name: string;
          grade: string;
          isPrivate: boolean;
        }>;
        SelectedEvent?: { [key: string]: any } | null;
      }>,
    ) => {
      const { key, updates = {}, SelectedEvent } = action.payload;
      const item = state.items.find((item) => item.key === key);

      if (item) {
        Object.assign(item, updates);

        if (SelectedEvent) {
          item.SelectedEvent = {
            ...SelectedEvent,
            key,
          };
        } else {
          delete item.SelectedEvent;
        }
      }
    },
    removeVivaItem: (
      state,
      action: PayloadAction<{
        data: VivaCartItem;
        persist: boolean;
        strictRemove: boolean;
      }>,
    ) => {
      const { data, persist, strictRemove } = action.payload;

      if (!persist) {
        localStorage.removeItem("promoCodeData");
        localStorage.removeItem("formData");
      }

      if (!strictRemove) {
        // remove all events having group_name
        const matchCriteria = {
          group_name: data?.group_name,
          sub_type: data?.sub_type || data?.["Sub Type"],
          venue_name: data?.venue_name,
          host_school_name: data?.host_school_name,
          age: data?.age,
          gender: data?.gender,
          participation_type: data?.participation_type,
          // isPrivate: data?.isPrivate,
        };

        const index = state.items.findIndex((item) =>
          isMatch(item, matchCriteria),
        );

        if (index !== -1) {
          state.items[index].inCart -= 1;
          if (state.items[index].inCart <= 0) {
            state.items.splice(index, 1);
          }
        }
      } else {
        // remove particular event that have key
        const index = state.items.findIndex((item) => item.key === data.key);

        if (index !== -1) {
          state.items[index].inCart -= 1;
          if (state.items[index].inCart <= 0) {
            state.items.splice(index, 1);
          }
        }
      }
    },
    clearVivaCart: (state) => {
      state.items = [];
    },

    removeAndAddVivaItems: (
      state,
      action: PayloadAction<{ data: VivaCartItem }>,
    ) => {
      localStorage.removeItem("promoCodeData");
      localStorage.removeItem("formData");
      state.items = [{ ...action.payload.data, inCart: 1 }];
    },
  },
});

export const {
  addVivaItem,
  updateVivaItemAttributes,
  removeVivaItem,
  clearVivaCart,
  removeAndAddVivaItems,
  addVivaSameItem,
} = vivaCartSlice.actions;

export const selectVivaCartItems = (state: { vivaCart: CartState }) =>
  state.vivaCart.items;

export default vivaCartSlice.reducer;
